import React, { useEffect, useState } from 'react';
import { Box, Button, Container, Typography, Stack } from '@mui/material';
import LoginModal from './LoginModal';

const Landing = ({ defaultOpenLogin = false }) => {
  const [open, setOpen] = useState(defaultOpenLogin);

  useEffect(() => {
    setOpen(defaultOpenLogin);
  }, [defaultOpenLogin]);

  return (
    <Box
      sx={{
        position: 'relative',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        // Set your image in public folder
        backgroundImage: 'url(/bg.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(180deg, rgba(50, 51, 56,0.55) 0%, rgba(50, 51, 56,0.35) 100%)',
        },
      }}
    >
      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={4} alignItems="center">
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="h2"
              sx={{
                fontWeight: 900,
                letterSpacing: '.06em',
                mb: 2,
                color: '#ffffff',
                textShadow: '0 6px 24px rgba(50, 51, 56,.35)'
              }}
            >
              ERP
            </Typography>
            <Typography variant="h5" sx={{ color: 'rgba(255,255,255,.85)', mb: 3 }}>
              سامانه فرآیند تولید
            </Typography>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <Button
                variant="contained"
                onClick={() => setOpen(true)}
                sx={{
                  px: 4,
                  py: 1.5,
                  fontWeight: 800,
                  borderRadius: 3,
                  background: 'linear-gradient(90deg, #b79961, #a68955)',
                  boxShadow: '0 10px 25px rgba(50, 51, 56,.35)',
                  '&:hover': { background: 'linear-gradient(90deg, #a68955, #b79961)' }
                }}
              >
                ورود به سامانه
              </Button>
            </Stack>
          </Box>
          
        </Stack>
      </Container>

      <LoginModal open={open} onClose={() => setOpen(false)} />
    </Box>
  );
};

export default Landing;


